import { TRANSITION_TYPE } from '../../enums/model.enums';
import { isUndefined } from 'util';
import { Location } from '../location';
export class TransitionSection {
    /**
     * constructor of class
     * please use factory instead
     * @see {this.factory)
     * @param type
     */
    constructor(type, pathOnMap) {
        this._type = type;
        this._pathOnMap = pathOnMap;
    }
    /**
     * Factory method to create an instance of this class without
     * having to correctly fill the constructor.
     * !!! You should always use this instead of the constructor !!!
     * @param values
     * @returns {TransitionSection}
     */
    static factory(values) {
        const sanitizedValues = {};
        sanitizedValues.type = !isUndefined(values.type) ? values.type : TRANSITION_TYPE.WALKING;
        sanitizedValues.pathOnMap = [];
        if (values.pathOnMap) {
            for (const location of values.pathOnMap) {
                sanitizedValues.pathOnMap.push(Location.factory(location));
            }
        }
        return new TransitionSection(sanitizedValues.type, sanitizedValues.pathOnMap);
    }
    /**
     * gets the internal _duration
     * @returns {TRANSITION_TYPE}
     */
    get type() {
        return this._type;
    }
    /**
     * sets the internal _duration
     * @param value
     */
    set type(value) {
        this._type = value;
    }
    /**
     * gets the array of locations that describes the taken path
     * @returns {Location[]} Location Array
     */
    get pathOnMap() {
        return this._pathOnMap;
    }
    /**
     * sets the array of locations that describes the taken path
     * @param value Location Array
     */
    set pathOnMap(value) {
        this._pathOnMap = value;
    }
}
//# sourceMappingURL=transitionSection.js.map